import { IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import {
  alertCircleOutline,
  informationCircleOutline,
  warningOutline,
} from 'ionicons/icons';
import { ReactElement, useMemo } from 'react';
import './callout-banner.css';

interface CalloutBannerProps {
  message: string;
  type?: 'info' | 'warning' | 'error';
  calloutBannerProps?: React.HTMLAttributes<HTMLDivElement>;
}

const CalloutBanner = (
  props: CalloutBannerProps & React.HTMLAttributes<HTMLDivElement>
): ReactElement => {
  const { message, type = 'info', calloutBannerProps } = props;

  const icon = useInfoBoxIcon(type);
  const classes = useInfoBoxClasses(type);

  return (
    <div {...calloutBannerProps}>
      <IonGrid className={classes.join(' ')}>
        <IonRow>
          <IonCol size="1" className="icon-container">
            <IonIcon icon={icon} />
          </IonCol>
          <IonCol>{message}</IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

const useInfoBoxIcon = (type: 'info' | 'warning' | 'error') => {
  return useMemo(() => {
    switch (type) {
      case 'info':
        return informationCircleOutline;
      case 'warning':
        return warningOutline;
      case 'error':
        return alertCircleOutline;
    }
  }, [type]);
};

const useInfoBoxClasses = (type: 'info' | 'warning' | 'error') => {
  return useMemo(() => {
    return ['info-box', `info-box--${type}`];
  }, [type]);
};

export { CalloutBanner };
